
import { Howl } from 'howler';

/*
const audio = {
    levelComplete: new Audio(location + 'echo_affirm1.mp3'),
    restart: new Audio(location + 'melodic3_affirm.mp3'),
    purchaseSuccess: new Audio(location + 'melodic5_affirm.mp3'),
    clearWord: new Audio(location + 'blip1.mp3'),
    selectLetter: new Audio(location + 'blip_click.mp3'),
    tap: new Audio(location + 'pop_click.mp3'),
    restartNeeded: new Audio(location + 'bass_affirm.mp3'),
}

const Sounds = {
    play: (name) => {
        if (typeof audio[name] !== 'undefined') {
            //let audioObj = new Audio(audio[name]);
            let promise = audio[name].cloneNode(true).play();
            let timestamp = new Date().getTime();
            promise.then(() => {
                // Played sound successfully
                console.log('Took', new Date().getTime() - timestamp);
            }).catch((error) => {
                // Error playing sound...
            });
        }
    }
}
*/

const loc = 'audio/mp3/';
const ext = '.mp3';

const audio = {
    levelComplete: new Howl({ src: loc + 'echo_affirm1' + ext }),
    restart: new Howl({ src: loc + 'melodic3_affirm' + ext }),
    purchaseSuccess: new Howl({ src: loc + 'melodic5_affirm' + ext }),
    clearWord: new Howl({ src: loc + 'blip1' + ext }),
    selectLetter: new Howl({ src: loc + 'blip_click' + ext }),
    tap: new Howl({ src: loc + 'pop_click' + ext }),
    restartNeeded: new Howl({ src: loc + 'bass_affirm' + ext }),
}

const Sounds = {
    play: (name) => {
        if (typeof audio[name] !== 'undefined')
            audio[name].play();
    }
}

export default Sounds;
